import React, { useState } from 'react';
import TableCard from '../components/table_card/View';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import { useMeanIdeaRating } from './useMeanIdeaRating';
import { useIdeaSplit } from '../hook/useIdeaSplit';

const EvaluatorSection = (props) => {
  const {
    isHackathonChallenge,
    isValidateStatus,
    isEvaluator = false,
    isAdmin = false,
    isOrganizer,
    isInnovator,
    classes = {},
    evaluators = [],
    isEligible,
    loginUserEmail,
    onRemove,
    isCheckForEvalutor,
    onScorecard,
    handleEvaluatorClick,
    isLoading = false,
    setDialogEvaluatorShowAllOpen = () => {},
    setDialogScoreCardShowAllOpen = () => {},
    setDialogBusinessEvaluatorShowAllOpen = () => {},
    setDialogBusinessScoreCardShowAllOpen = () => {},
    getJsonEvaluatorForRatingIsLoading ,
  } = props || {};


  const ideaSplit = useIdeaSplit(evaluators);
  
  // const showEvaluators = Array.isArray(ideaSplit.eIdeas) && ideaSplit.eIdeas.length > 0;
  // const showBusinessEvaluators = Array.isArray(ideaSplit.bIdeas) && ideaSplit.bIdeas.length > 0;
   const canSeeScorecard = (isAdmin || isEvaluator  || isOrganizer ) && evaluators?.length > 0;
  // const canSeeScorecard = (isAdmin || (isEvaluator && isEligible) || isOrganizer ) && evaluators?.length > 0; 
  // const canSeeBusinessScorecard = (isAdmin || (isEvaluator && !isEligible) || isOrganizer ) && evaluators?.length > 0; 

// 1. Safely check E-type ideas using optional chaining and .some()
const hasMatchingUserEvaluator = Array.isArray(ideaSplit?.eIdeas) 
  ? ideaSplit.eIdeas.some(item => item?.userEmail === loginUserEmail)
  : (console.warn("ideaSplit.eIdeas is not a valid array."), false);

// 2. Safely check Business-type ideas using optional chaining and .some()
const hasMatchingUserEvaluatorForBusiness = Array.isArray(ideaSplit?.bIdeas) 
  ? ideaSplit.bIdeas.some(item => item?.userEmail === loginUserEmail)
  : (console.warn("ideaSplit.bIdeas is not a valid array."), false);



  const { mean, count } = useMeanIdeaRating(ideaSplit.eIdeas);
  const overallRating = Math.round(mean)
  const { mean:b_mean,  } = useMeanIdeaRating(ideaSplit.bIdeas);
  const B_overallRating = Math.round(b_mean)

  return (

    <div>
             {/* when isHackathonChallenge is true than visible to scorecard for hackthon periods */}
            {/* Right Side: Prominent Scorecard Engagement Box */}
        {   isValidateStatus === "DRAFT" ? null :  isCheckForEvalutor && (
              <div>
                <button
                  type="button"
                  disabled={getJsonEvaluatorForRatingIsLoading}
                  onClick={onScorecard}
                  style={{
                    width: '100%',
                    padding: '24px',
                    fontSize: '1.5rem',
                    lineHeight: '1.4',
                    fontFamily: 'VodafoneRg-bold, sans-serif',
                    color: '#ffffff',
                    backgroundColor: getJsonEvaluatorForRatingIsLoading ? '#cccccc' : '#e60000',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: getJsonEvaluatorForRatingIsLoading ? 'not-allowed' : 'pointer',
                    boxShadow: '0px 4px 12px rgba(230, 0, 0, 0.25)',
                    transition: 'all 0.2s ease-in-out',
                    textAlign: 'center'
                  }}
                  onMouseEnter={(e) => {
                    if (!getJsonEvaluatorForRatingIsLoading) e.currentTarget.style.backgroundColor = '#b30000';
                  }}
                  onMouseLeave={(e) => {
                    if (!getJsonEvaluatorForRatingIsLoading) e.currentTarget.style.backgroundColor = '#e60000';
                  }}
                >
                  {getJsonEvaluatorForRatingIsLoading ? 'Loading Template...' : 'Rate Scorecard'}
                </button>
              </div> 
              )
        }


      {  canSeeScorecard && (
        <div className={classes.blockContent}>
          <TableCard
            isAdmin={isAdmin}
            isOrganizer={isOrganizer}
            // isInnovator={isInnovator}
            title="Evaluators"
            header={['E-mail', 'Action']}
            data={ideaSplit.eIdeas}
            onClick={onRemove}
            disabled={isLoading}
            onShowAll={() => setDialogEvaluatorShowAllOpen(true)}
          />
        </div>
      )}

   

      {
        // showEvaluators && (
         canSeeScorecard && (
          <TableCard
            title={`Scorecard Overall Rating - ${overallRating}%`}
            header={["E-mail", "Rating", "Action"]}
            data={ideaSplit.eIdeas}
            isEvaluator={isEvaluator}
            isAdmin={isAdmin}
            isOrganizer={isOrganizer}
            loginUserEmail={loginUserEmail}
            HideEyeIconForOtherEvaluator={hasMatchingUserEvaluator}
            onClick={handleEvaluatorClick}
            disabled={getJsonEvaluatorForRatingIsLoading}
            onShowAll={() => setDialogScoreCardShowAllOpen(true)}
          />
        )
      }

      {  canSeeScorecard && (
        <div className={classes.blockContent}>
          <TableCard
            isAdmin={isAdmin}
            isOrganizer={isOrganizer}
            // isInnovator={isInnovator}
            title="Business Evaluators"
            header={['E-mail', 'Action']}
            data={ideaSplit.bIdeas}
            onClick={onRemove}
            disabled={isLoading}
            onShowAll={() => setDialogBusinessEvaluatorShowAllOpen(true)}
          />
        </div>
      )}

      {
        canSeeScorecard && (
          <TableCard
            title={`Business Scorecard Overall Rating - ${B_overallRating}%`}
            header={["E-mail", "Rating", "Action"]}
            data={ideaSplit.bIdeas}
            isEvaluator={isEvaluator}
            isAdmin={isAdmin}
            isOrganizer={isOrganizer}
            loginUserEmail={loginUserEmail}
            HideEyeIconForOtherEvaluator={hasMatchingUserEvaluatorForBusiness}
            onClick={handleEvaluatorClick}
            disabled={getJsonEvaluatorForRatingIsLoading}
            onShowAll={() => setDialogBusinessScoreCardShowAllOpen(true)}
          />
        )
      }


    </div>

  )
}

export default EvaluatorSection;
